export default __webpack_public_path__ + "static/media/mountain-6.ef693866.jpg";